import { Box, FormControlLabel, Checkbox, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
export const ComingSoon = () => {
  const {
    t
  } = useTranslation();
  return <Box data-cy="RulesTab" display="flex" flexDirection="column" height="100%" justifyContent="center" alignItems="center" data-sentry-element="Box" data-sentry-component="ComingSoon" data-sentry-source-file="ComingSoon.tsx">
      <Box display="flex" flexDirection="column" justifyContent="flex-start" gap="20px" data-sentry-element="Box" data-sentry-source-file="ComingSoon.tsx">
        <FormControlLabel control={<Checkbox disabled />} label={<>
              <Typography variant="body2">{t("schema.uniqueField")}</Typography>
              <Typography variant="body3" color="text.secondary">
                {t("schema.uniqueFieldDescription")}
              </Typography>
            </>} data-sentry-element="FormControlLabel" data-sentry-source-file="ComingSoon.tsx" />
        <FormControlLabel control={<Checkbox disabled />} label={<>
              <Typography variant="body2">
                {t("schema.defaultValue")}
              </Typography>
              <Typography variant="body3" color="text.secondary">
                {t("schema.defaultValueDescription")}
              </Typography>
            </>} data-sentry-element="FormControlLabel" data-sentry-source-file="ComingSoon.tsx" />
        <FormControlLabel control={<Checkbox disabled />} label={<>
              <Typography variant="body2">
                {t("schema.limitCharacterCount")}
              </Typography>
              <Typography variant="body3" color="text.secondary">
                {t("schema.limitCharacterCountDescription")}
              </Typography>
            </>} data-sentry-element="FormControlLabel" data-sentry-source-file="ComingSoon.tsx" />
      </Box>
      <Typography variant="h5" mt={4} mb={1.5} fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="ComingSoon.tsx">
        {t("schema.fieldValidationTitle")}
      </Typography>
      <Typography variant="body2" color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="ComingSoon.tsx">
        {t("schema.comingSoon")}
      </Typography>
    </Box>;
};